module.exports = __webpack_public_path__ + "static/media/consulenza1.83f6cba1.png";